import ServiceModel   from '@models/ServiceModel';
import ApiConnectorV4 from '@/models/ApiConnectorV4';

const service = window.APP_CONFIG.services.find(service => service.id === 'admin');

export const adminConnector = new ApiConnectorV4({baseURL: service?.configurations.api_endpoint});

export default class AdminServiceModel extends ServiceModel {
    public static get connector() {
        return adminConnector;
    }

    public static serviceName = 'admin';
    public static partitionName = '$';
}
